import React, { useState, useEffect } from "react";

import { func_validation, isArrayNotEmpty } from "functions";
import { ListBox } from "components/form/ListBox";

export function useUserGroup(props) {
    const {
        userGroupList, getUserGroupList_requesting,
        userGroupLabels,

        role,
        isFormSubmissionAttempted
    } = props;

    const [selectedUserGroups, setSelectedUserGroups] = useState([]);
    const [isUserGroupDisabled, setIsUserGroupDisabled] = useState(false);

    useEffect(() => {
        if (func_validation.isStringTrimNotEmpty(role) &&
            (!func_validation.isStringEqual_caseInsensitive(role, "Internal")))
            setIsUserGroupDisabled(true);
        else setIsUserGroupDisabled(false);
    });

    let userGroupDisplay = (
        <ListBox
            className={"userUpdate-inputWrapper-userGroup"}
            listWrapperClassName={"userUpdate-inputWrapper-userGroup-listWrapper"}
            listBodyClassName={"userUpdate-inputWrapper-userGroup-listBody"}

            customSelectionIndicatorTxt={"User Group(s) Selected"}

            title={"Add User Group Into User"}
            // isInputRequired={(!func_validation.isStringEqual_caseInsensitive(role, "Dealer"))}
            isFormSubmissionAttempted={isFormSubmissionAttempted}

            list={(func_validation.isUserAccessGranted(props, "Internal_UserGroupMapping_View")) && isArrayNotEmpty(userGroupList) && isArrayNotEmpty(userGroupLabels)? 
                userGroupLabels.map((name, idx) => {
                    return {
                        label: name, 
                        data: userGroupList[idx]
                    }
            }):[]}
            isListLoading={getUserGroupList_requesting}

            updateParentState={setSelectedUserGroups}
            isResetRequired={isUserGroupDisabled}
            isDisabled={isUserGroupDisabled || func_validation.isUserAccessDenied(props, "Internal_UserGroupMapping_Add")}
        />
    )

    return {
        selectedUserGroups,
        userGroupDisplay
    }
}